export const ANDY: string = "Andy";
const PREFIX: string = ANDY + ".";

export const LOAD_MANUAL_PROGRESS: string = PREFIX + "LoadManualProgress";
export const FORCE_ONBOARDING_HINT: string = PREFIX + "ForceOnboardingHint";
export const KEYBOARD_FOCUS_BEGIN: string = PREFIX + "KeyboardFocusBegin";
export const KEYBOARD_FOCUS_END: string = PREFIX + "KeyboardFocusEnd";
export const KEYBOARD_REFOCUS: string = PREFIX + "KeyboardRefocus";
export const KEYBOARD_REMAP: string = PREFIX + "KeyboardRemap";
export const ACTIVE_PAINT_SELECTED: string = PREFIX + "ActivePaintSelected";
export const ACTIVE_PAINT_DESELECTED: string = PREFIX + "ActivePaintDeselected";

export const GAME_ENTERED: string = PREFIX + "GameEntered";
export const PAINTABLE_GAME_ENTERED: string = PREFIX + "PaintableGameEntered";
export const GALLERY_ENTERED: string = PREFIX + "GalleryEntered";
export const GALLERY_ITEM_FINISHED: string = PREFIX + "GalleryItemFinished";
export const PAINTABLE_LAYER_PAINTED: string = PREFIX + "PaintableLayerPainted";
export const PINATA_HIT: string = PREFIX + "PinataHit";
export const PATCH_SELECTED: string = PREFIX + "PatchSelected";
export const PATCH_DESELECTED: string = PREFIX + "PatchDeselected";
export const PATCH_ADDED: string = PREFIX + "PatchAdded";
export const HIEROGLYPH_CHANGED: string = PREFIX + "HieroglyphChanged";
export const BEGIN_ZOOM: string = PREFIX + "BeginZoom";
export const ONBOARDING_START: string = PREFIX + "OnboardingStart";
export const ONBOARDING_FINISH: string = PREFIX + "OnboardingFinish";
export const ONBOARDING_ARROW_SHOW: string = PREFIX + "OnboardingArrowShow";
export const FUN_FACT_START: string = PREFIX + "FunFactStart";
export const PLAY_FUN_FACT: string = PREFIX + "PlayFunFact";
export const FUN_FACT_COMPLETE: string = PREFIX + "FunFactComplete";
export const PLAY_CAPTION: string = PREFIX + "PlayCaption";
export const STOP_CAPTION: string = PREFIX + "StopCaption";
